import { CompoundButton, mergeStyles, Stack } from '@fluentui/react';
import { useEffect } from 'react';

import { peopleIcon } from '../../../../../utils/icons';
import { actions as accountActions } from '../../../../Accounts/slice';
import { actions } from '../../../slice';

export default (props: { activeAccountId?: string }) => {
  const setModalOpen = (bool: boolean) => {
    actions.setFormVariable(["isAccountModalOpen", bool]);
  };

  useEffect(() => setModalOpen(false), [props.activeAccountId]);

  return (
    <div className={containerStyles}>
      <Stack horizontal tokens={{ childrenGap: 10 }}>
        <CompoundButton
          text={"Hesap Seç"}
          secondaryText={"Müşteri hesabı seçmek için tıklayın."}
          iconProps={peopleIcon}
          className={buttonStyles}
          onClick={() => {
            accountActions.reset();
            setModalOpen(true);
          }}
          primary
        />
        <CompoundButton
          text={"Perakende Hesabı Seç"}
          iconProps={{ iconName: "PeoplePause" }}
          className={buttonStyles}
          onClick={setDefaultAccount}
        />
      </Stack>
    </div>
  );
};

const setDefaultAccount = () =>
  actions.setFormVariable([
    "activeAccount",
    {
      id: "mYYfPAtxPDZjUigTaQsg",
      versionId: "t25dZ0vBnC89jpfJsJam",
      displayName: "Perkende",
    },
  ]);
const buttonStyles = mergeStyles({
  // width: "80%",
  // marginLeft: "10%",
  width: "100%",
});
const containerStyles = mergeStyles({
  // maxWidth: "500px",
  // width: "80%",
  // marginLeft: "10%",
  // transform: "translate(-50%, 0)",
  // marginLeft: "50%",
});
